import React from "react";
import '../../pages/Home/Home.css';
import { useState } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const HeaderDummy = () => {

  const [userData, setUserData] = useState(null);
    const [openDropdown, setOpenDropdown] = useState(false);

    const dropdownRef = useRef();
    const navigate = useNavigate();

     useEffect(() => {
        const data = localStorage.getItem('userData');
      
        if (data) {
          let parsedData = JSON.parse(data);
      
      
          // Check if parsedData is still a string (double stringified case)
          if (typeof parsedData === 'string') {
            parsedData = JSON.parse(parsedData);
          }
      
          if (parsedData && parsedData[0]) {
            setUserData(parsedData[0])
          }
        }
        else {
          localStorage.removeItem("authToken");
          localStorage.removeItem("userData");
          localStorage.removeItem("accessToken")
          localStorage.removeItem('refreshToken');
        }
            const handleClickOutside = (e) => {
          if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpenDropdown(false);
          }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
      }, []);
    const handleLogout = () => {
  
    // Clear all authentication data
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("accessToken")
    localStorage.removeItem('refreshToken');

    // Clear user state
    setUserData(null);
    setOpenDropdown(false);

   navigate(`/login`);
  };
  return (
    <header className="headerDummy">
      <h1 className="simple-header-text">German Standard Group</h1>
      {userData && (
            <div className="user-dropdown" ref={dropdownRef}>
              {/* <img
                      src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
                      alt="avatar"
                      className="avatar"
                    /> */}
              <button className="user-btn" onClick={() => setOpenDropdown(!openDropdown)}>
                {userData.LoginName} 
              </button>

              {openDropdown && (
                <div className="dropdown-content">
                  {/* <div className="profile-section">
                    <img
                      src="https://via.placeholder.com/50"
                      alt="avatar"
                      className="avatar"
                    />
                    <div className="profile-info">
                      <span className="profile-name">{userData.LoginName}</span>
                      <span className="profile-role">User</span>
                    </div>
                  </div> */}
                  <button className="logout-btn" onClick={handleLogout}>
                    Log Out
                  </button>
                </div>
              )}
            </div>
          )}
    </header>
  );
};

export default HeaderDummy;
